<template>
<div @click.self="closePhoto" class="bg-fixed bg-gray-900 md:p-16 p-2">
    <div class="max-w-lg rounded overflow-hidden shadow-lg m-auto mt-8 bg-white">
        <img class="w-full" src="https://source.unsplash.com/ogM9EkNoAfM" alt="Sunset in the mountains">
        <div class="px-6 py-4" v-if="photo.description">
            <p class="text-gray-700 text-base">
                {{ photo.description }}
            </p>
        </div>
        <div class="px-6 py-2" v-if="photo.mentions && photo.mentions.length > 0">
            <span class="inline-block bg-gray-200 rounded-full px-3 py-1 my-1 text-sm font-semibold text-gray-700 mr-2"
                v-for="mention in photo.mentions" :key="mention">@{{ mention }}</span>
        </div>
        <div class="px-6 py-2" v-if="photo.hashtags && photo.hashtags.length > 0">
            <span class="inline-block bg-gray-200 rounded-full px-3 py-1 my-1 text-sm font-semibold text-gray-700 mr-2"
                v-for="hashtag in photo.hashtags" :key="hashtag">#{{ hashtag }}</span>
        </div>
    </div>
    
</div>
</template>
<script>
export default {
    name: 'Photo',
    data() {
        return {
            photo: {
                id: 2,
                description: "We don't need eyes to know if a person is good or bad, even though it may take a while to realize it.",
                url: 'https://source.unsplash.com/wZEf1Y6Kxs0',
                year: 2014,
                hashtags: [
                    "isc",
                    "puberty",
                    "freckles",
                    "girl",
                ],
                mentions: [
                    'oceanswide', 'nathannichols'
                ]
            }
        }
    },
    methods: {
        closePhoto() { return this.$router.push('/gallery') }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/gallery/Photo.vue